import * as React from "react";

export default () => {
  return <div>Bilagor som tillhör huvuddokumentet för uppsägningen.</div>;
};
